import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles(() => ({
    root: {
        fontSize: 14,
        fontWeight: 'initial',
        lineHeight: '16px',
        padding: 8,
        borderRadius: 8,
    },
    warning: {
        backgroundColor: '#fdf7ec',
        border: '1px solid #fd9900',
    },
    error: {
        backgroundColor: '#fdf0f2',
        border: '1px solid #f22e5e',
    },
    success: {
        backgroundColor: '#eef8f0',
        border: '1px solid #009a00',
    },
}));
const ICONS = {
    warning: '⚠️',
    success: '✅',
    error: '⛔',
};
function Alert({ children, className, type, }) {
    const classes = useStyles();
    return (React.createElement("p", { className: classNames(classes.root, classes[type], className) },
        ICONS[type],
        " ",
        children));
}
export default Alert;
//# sourceMappingURL=Alert.js.map